const report = {
  sellReport: 'analytics/userdietorder',
  zirehReports: 'analytics/user-and-order',
  ticketReports: 'analytics/ticket',
  totalUser: 'analytics/paiduser',
  userStatusGrowthReport: 'analytics/user-status'
}
export default report
